import React from 'react'
import { motion } from 'framer-motion'
import './cafe-1.css'

const Cafe1 = ({ isOpen }) => {
  const EmptyAnimation = {
    width: ['5%', '65%'],
  }

  const EmptyTransition = {
    duration: 0.5,
    delay: 4,
  }

  const SeatVariants = {
    open: {
      opacity: 1,
    },
    closed: {
      opacity: 0,
    },
  }

  const SeatTransition = {
    duration: 1,
    delay: 4.5,
  }

  const MainVariants = {
    open: {
      transform: 'translate(0%, 0%)',
      opacity: 1,
    },
    closed: {
      transform: 'translate(50%, 50%)',
      opacity: 0,
    },
  }

  const MainTransition = {
    duration: 0.5,
    delay: 3.5,
  }

  return (
    <motion.div
      className="cafe-container1"
      animate={isOpen ? 'open' : 'closed'}
      initial={false}
      transition={MainTransition}
      variants={MainVariants}
    >
      <div className="name">星巴克(新大興門市)</div>
      <div className="image-gallery">
        <img src="image/starbuck1.jpeg" alt="#" />
        <img src="image/starbuck2.jpeg" alt="#" />
        <img src="image/starbuck3.jpeg" alt="#" />
      </div>
      <div className="tag">#好讀書 #好舒適 #商業</div>
      <motion.div
        className="empty"
        animate={EmptyAnimation}
        transition={EmptyTransition}
      >
        <motion.div
          className="seat"
          animate={isOpen ? 'open' : 'closed'}
          initial={false}
          variants={SeatVariants}
          transition={SeatTransition}
        >
          剩餘 30% 座位
        </motion.div>
      </motion.div>
    </motion.div>
  )
}

export default Cafe1
